const ENDPOINT = '/landlord/api/client-errors';

export function reportError(error: unknown, context?: Record<string, unknown>): void {
  const message = error instanceof Error ? error.message : String(error);
  const stack = error instanceof Error ? error.stack : undefined;

  const payload = {
    message,
    stack,
    context,
    url: window.location.href,
    userAgent: navigator.userAgent.slice(0, 300),
    timestamp: new Date().toISOString(),
  };

  fetch(ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).catch(() => {
    // Never let error reporting break the caller; log locally as fallback
    console.error('[ErrorReporter]', message, context);
  });
}

export function installGlobalErrorHandlers(): void {
  window.addEventListener('unhandledrejection', (event) => {
    reportError(event.reason, { type: 'unhandledrejection' });
  });

  window.addEventListener('error', (event) => {
    if (event.error) {
      reportError(event.error, {
        type: 'uncaughtError',
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      });
    }
  });
}
